import React from "react";
import { fileUrl } from "../lib/api";

// Gambar banner template (atas/bawah teks) untuk dialog Preview ucapan.
export const UcapanGambar = ({ meta, posisi, testId = "ucapan-gambar" }) => {
  if (!meta?.gambar_path || (meta.posisi_gambar || "atas") !== posisi) return null;
  return <img src={fileUrl(meta.gambar_path)} alt="Kartu ucapan" className="w-full max-h-56 object-contain rounded-xl border border-slate-100 bg-slate-50" data-testid={`${testId}-${posisi}`} />;
};
